module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/image-815e812eb9d14872d0553f210fcc43dc.svg";